import {
  filterConfigs,
  SearchFilter,
} from '@aibees/elephant/feature/search-filters';
import { pathToFilterArray } from '@aibees/elephant/feature/search-filters/components/filter-tags/utils';
import { SearchTable } from '@aibees/elephant/types';
import { Maybe } from '@aibees/shared/definition';
import { useBaseFilterByName } from './use-base-filter-by-name';

export function useFilterRootParent(
  searchTable: Maybe<SearchTable>,
  key: keyof SearchFilter,
  value: string
) {
  const rootParentName = searchTable
    ? pathToFilterArray(
        filterConfigs[searchTable] as SearchFilter[],
        key,
        value,
        'name'
      ).at(0)
    : '';

  const result = useBaseFilterByName(searchTable, rootParentName ?? '');

  if (!searchTable || !result) return;

  return result;
}
